/**
 * 空 style 的渲染兜底（设计像素）。只用于预览/检查器占位，不写入 schema。
 * 与 C 端 `N × 2 rpx` 同一套数：375 宽屏上 1 设计像素 = 1 CSS 像素。
 */
export const WIDGET_STYLE_FALLBACKS = {
  radius: 8,
  mediaHeight: 160,
  fontSize: 16,
  richTextFontSize: 13,
  lineHeight: 1.75,
  gap: 8,
} as const

export function styleNumberOrFallback(
  style: Record<string, unknown> | null | undefined,
  key: string,
  fallback: number,
): number {
  const raw = style?.[key]
  if (raw === null || raw === undefined || raw === '') return fallback
  const num = Number(raw)
  return Number.isFinite(num) ? num : fallback
}
